<div class="container-md p-md-0">
  <ts-asset-selection
    header="{{ 'my_eligible_lines' | translate }}"
    no_asset_text="{{ 'no_eligible_lines' | translate }}"
    [asset_fields]="['plan', 'plan_features', 'add_on_features']"
    [existing_asset]="shopping_cart && shopping_cart.existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>
